<template>
  <div class="ui-dadata-autocomplete" v-click-outside="handleClickOutside">
    <input
      class="ui-dadata-autocomplete__input t-input"
      :class="{ _error: error, _valid: valid }"
      type="text"
      :placeholder="placeholder"
      v-model="inputValue"
      @input="debouncedInput"
      @focus="handleFocus"
    >
    <transition name="fade">
      <div
        v-if="isOpened"
        class="ui-dadata-autocomplete__dropdown"
      >
        <div
          v-if="isPending"
          class="ui-dadata-autocomplete__text ui-dadata-autocomplete__text--secondary ui-dadata-autocomplete__title  ui-dadata-autocomplete__loader"
        >Поиск...</div>

        <template v-else>
          <template v-if="inputValue.length">
              <ul
                v-if="options.length"
                class="ui-dadata-autocomplete__list"
              >
                <li
                  v-for="option in options"
                  class="ui-dadata-autocomplete__list-item"
                  @click="handleItemClick(option)"
                >
                  <span
                    class="ui-dadata-autocomplete__text"
                  >г. {{ option.city }}</span>
                  <span>
                    {{ option.country }}, {{ option.city }},
                  </span>
                  <span>
                    <!-- {{ option.district && "федеральный округ," }} -->
                    {{ option.region_with_type && `Регион (область): ${option.region_with_type}` }},
                  </span>
                  <span>
                    {{ option.index && `Индекс: ${option.index}` }}
                  </span>
                </li>
              </ul>

              <div
                v-else
                class="ui-dadata-autocomplete__text ui-dadata-autocomplete__title ui-dadata-autocomplete__text--secondary"
              >Ничего не найдено</div>
          </template>
  
          <div
            class="ui-dadata-autocomplete__text ui-dadata-autocomplete__title ui-dadata-autocomplete__text--secondary"
            v-else
          >Пример: г Москва</div>
        </template>

      </div>
    </transition>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { debounce } from 'lodash';

export default {
  name: 'ui-dadata-organisation-autocomplete',
  props: {
    value: {
      type: Object,
      default: null,
    },
    placeholder: {
      type: String,
      default: ''
    },
    error: {
      type: Boolean,
      default: false
    },
    valid: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isOpened: false,
      inputValue: '',
      prevOption: null,
      options: [],
      isPending: false,
      isFirstTouch: true
    }
  },
  computed: {
    debouncedInput () {
      return debounce(this.handleInputChange, 500);
    }
  },
  methods: {
    ...mapActions({
      getCityDadata: 'getCityDadata',
    }),
    handleFocus (e) {
      this.isOpened = true;
      this.$emit('focus', e)
    },
    async handleInputChange (e) {
      try {
        const res = await this.getCityDadata({ query: this.inputValue, token: this.$root.siteDadataKey || undefined });
        this.options = res;
      } finally {
        this.isPending = false
      }
    },
    resetField () {
      this.inputValue = ''
      this.$emit('update:value', null);
    },
    setCurrentOption (option) {
      if (!option) return this.resetField();

      this.$emit('update:value', option);
      this.inputValue = option.city;
      this.options = [ option ];
    },
    handleClickOutside () {
      if (!this.isOpened) return;

      this.setCurrentOption(this.value);

      this.isOpened = false;
    },
    handleItemClick (option) {
      this.setCurrentOption(option);
      this.isOpened = false;
    },
  },
  watch: {
    inputValue (v) {
      this.isPending = true;
    },
    isOpened (v) {
      if (v) return;
      this.isPending = false;
    }
  }
}
</script>

<style lang="sass">
@import './styles'
</style>


// WEBPACK FOOTER //
// src/templates/components/ui-components/dadata-autocomplete/dadata-city-autocomplete.vue